import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AUTH_CLIENTID,
    tenantId: process.env.REACT_APP_AUTH_TENANTID,
    authority: process.env.REACT_APP_AUTH_AUTHORITY,
    knownAuthorities: [process.env.REACT_APP_AUTH_KNOWN_AUTHORITY],
    redirectUri: process.env.REACT_APP_AUTH_REDIRECTURI,
    postLogoutRedirectUri: process.env.REACT_APP_AUTH_POSTLOGOUT_REDIRECTURI, // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);
